module.exports = __webpack_public_path__ + "img/aygaz-conversion-club-infographic-01.c73efc98.jpg";